module.exports = __webpack_public_path__ + "static/media/Sequel100Black-65.46e04813.ttf";